import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export function Info() {
  const [huts, setHuts] = useState([]);
  useEffect(()=>{ api.get("/huts").then(r=>setHuts(r.data)); },[]);
  return (
    <div className="max-w-4xl mx-auto px-4 py-10" data-testid="info-page">
      <h1 className="font-serif text-4xl text-emerald-900 mb-6">Informations pratiques</h1>
      <div className="prose max-w-none text-stone-700">
        <p>La saison de réservation s'étend du <strong>21 août</strong> au <strong>31 janvier</strong>.</p>
        <p>La location se fait pour la <strong>hutte entière</strong>, seul ou à plusieurs.</p>
        <p>Chaque participant est limité à <strong>4 nuits maximum par saison</strong> (non nécessairement consécutives).</p>
        <p>À apporter : votre <strong>sac de couchage</strong> (hygiène), <strong>briquet ou allumettes</strong>, et de préférence vos <strong>propres couverts</strong>.</p>
        <p>La hutte doit être laissée <strong>parfaitement propre</strong>.</p>
        <p>Arrivée au plus tôt à <strong>14 h</strong> et départ au plus tard à <strong>11 h</strong>.</p>
      </div>
      <div className="mt-8 space-y-4">
        {huts.map(h => (
          <div key={h.id} className="p-5 bg-white border border-stone-200 rounded-xl">
            <h2 className="font-serif text-xl text-emerald-900">{h.name}</h2>
            {h.rules_summary && <p className="text-sm text-stone-700 mt-2 whitespace-pre-wrap">{h.rules_summary}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}

export function Regulations() {
  const [reg, setReg] = useState({});
  useEffect(()=>{ api.get("/content").then(r=>setReg(r.data.regulations || {})); },[]);
  return (
    <div className="max-w-4xl mx-auto px-4 py-10" data-testid="regulations-page">
      <h1 className="font-serif text-4xl text-emerald-900 mb-6">Règlement intérieur</h1>
      <p className="text-stone-700 mb-4">Le règlement intérieur des huttes pédagogiques AGCVS est disponible ci-dessous.</p>
      {reg.pdf_url ? (
        <a href={reg.pdf_url} target="_blank" rel="noreferrer" data-testid="reg-pdf-link"
          className="inline-block bg-emerald-800 hover:bg-emerald-900 text-white px-5 py-2.5 rounded-md">
          Télécharger le règlement (PDF) — version {reg.version}
        </a>
      ) : (
        <div className="p-4 bg-amber-50 border border-amber-200 rounded-md text-amber-900">Le document PDF sera bientôt disponible.</div>
      )}
    </div>
  );
}

export function Location() {
  const [huts, setHuts] = useState([]);
  useEffect(()=>{ api.get("/huts").then(r=>setHuts(r.data)); },[]);
  return (
    <div className="max-w-5xl mx-auto px-4 py-10" data-testid="location-page">
      <h1 className="font-serif text-4xl text-emerald-900 mb-6">Localisation et cartes</h1>
      <div className="grid gap-8">
        {huts.map(h => (
          <div key={h.id} className="p-5 bg-white border border-stone-200 rounded-xl">
            <h2 className="font-serif text-2xl text-emerald-900 mb-3">{h.name}</h2>
            <div className="grid gap-4 sm:grid-cols-2 text-sm">
              <div><div className="font-semibold text-emerald-800">Parking</div>{h.parking_map_url && <a href={h.parking_map_url} target="_blank" rel="noreferrer" className="text-emerald-700 hover:underline">Ouvrir dans Google Maps</a>}</div>
              <div><div className="font-semibold text-emerald-800">Hutte</div>{h.hut_map_url && <a href={h.hut_map_url} target="_blank" rel="noreferrer" className="text-emerald-700 hover:underline">Ouvrir dans Google Maps</a>}</div>
            </div>
            {(h.aerial_photo_url || h.cadastral_photo_url) ? (
              <div className="mt-4 grid gap-3 sm:grid-cols-2">
                {h.aerial_photo_url && <div><img src={h.aerial_photo_url.startsWith("http") ? h.aerial_photo_url : `${process.env.REACT_APP_BACKEND_URL}/api/files/${h.aerial_photo_url}`} alt="Vue aérienne" className="rounded-lg border"/></div>}
                {h.cadastral_photo_url && <div><img src={h.cadastral_photo_url.startsWith("http") ? h.cadastral_photo_url : `${process.env.REACT_APP_BACKEND_URL}/api/files/${h.cadastral_photo_url}`} alt="Cadastre" className="rounded-lg border"/></div>}
              </div>
            ) : <div className="mt-3 text-sm text-stone-500">Cartes aériennes à venir</div>}
          </div>
        ))}
      </div>
    </div>
  );
}

export function Contact() {
  const [f, setF] = useState({ name:"", email:"", message:"" });
  const [sent, setSent] = useState(false);
  const submit = async () => {
    try {
      await api.post("/contact", f);
      toast.success("Message envoyé"); setSent(true);
    } catch(e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="max-w-2xl mx-auto px-4 py-10" data-testid="contact-page">
      <h1 className="font-serif text-4xl text-emerald-900 mb-6">Contact</h1>
      <p className="text-stone-600 mb-2">Email : <a href="mailto:agcvs80@yahoo.com" className="text-emerald-700 hover:underline">agcvs80@yahoo.com</a></p>
      <p className="text-stone-600 mb-6">Adresse : 14 rue de la Vallée, 80132 Cahon, France</p>
      {sent ? <div className="p-4 bg-emerald-50 border border-emerald-200 rounded-md text-emerald-900">Merci, votre message a bien été envoyé.</div> :
      <div className="space-y-3 p-5 bg-white border border-stone-200 rounded-xl">
        <input placeholder="Nom" className="w-full border rounded-md px-3 py-2" value={f.name} onChange={e=>setF({...f,name:e.target.value})} data-testid="contact-name"/>
        <input placeholder="Email" type="email" className="w-full border rounded-md px-3 py-2" value={f.email} onChange={e=>setF({...f,email:e.target.value})} data-testid="contact-email"/>
        <textarea placeholder="Votre message" rows={5} className="w-full border rounded-md px-3 py-2" value={f.message} onChange={e=>setF({...f,message:e.target.value})} data-testid="contact-message"/>
        <button onClick={submit} className="bg-emerald-800 hover:bg-emerald-900 text-white px-5 py-2.5 rounded-md" data-testid="contact-submit">Envoyer</button>
      </div>}
    </div>
  );
}

export function Legal() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10 prose" data-testid="legal-page">
      <h1 className="font-serif text-3xl text-emerald-900">Mentions légales</h1>
      <p><strong>Éditeur :</strong> AGCVS – Association de Gestion Cynégétique en Vallée de Somme, association loi 1901.</p>
      <p><strong>Siège :</strong> 14 rue de la Vallée, 80132 Cahon, France.</p>
      <p><strong>Contact :</strong> agcvs80@yahoo.com</p>
      <p>Les informations légales complètes (SIREN, directeur de la publication, hébergeur) seront ajoutées ultérieurement par l'administrateur.</p>
    </div>
  );
}

export function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10 prose" data-testid="privacy-page">
      <h1 className="font-serif text-3xl text-emerald-900">Politique de confidentialité</h1>
      <p>Les données personnelles collectées (nom, prénom, email, téléphone) servent exclusivement à la gestion des réservations et à la communication liée à votre séjour. Elles ne sont ni vendues, ni cédées.</p>
      <p>Vous disposez d'un droit d'accès, de rectification et de suppression de vos données auprès de <a href="mailto:agcvs80@yahoo.com">agcvs80@yahoo.com</a>.</p>
    </div>
  );
}
